export const calculateVAK = (answers) => {
  let s = { 'Görsel': 0, 'İşitsel': 0, 'Dokunsal': 0 };
  
  Object.keys(answers).forEach(key => {
    const qId = parseInt(key);
    if (answers[key] === true || answers[key] === "true") {
      if (qId <= 20) s['Görsel']++;
      else if (qId <= 40) s['İşitsel']++;
      else s['Dokunsal']++;
    }
  });

  const max = Object.keys(s).reduce((a, b) => s[a] > s[b] ? a : b);
const sortedStyles = Object.entries(s)
  .sort((a, b) => b[1] - a[1])
  .map(([subject, score]) => ({ subject, score }));


// 🌟 ÖĞRENCİYE GÖSTERİLECEK VAK GERİ BİLDİRİMİ
const STUDENT_FEEDBACK_MAP = {
  "Görsel": {
    headline: "Görsel Çalışma Tercihin Öne Çıkıyor",
    message:
      "Şemalar, renkler, grafikler, haritalar ve görsel düzenlemeler çalışırken sana yardımcı olabilecek yollar arasında olabilir. Konuları zihin haritasına dönüştürmeyi, önemli noktaları renklerle ayırmayı ve kendi görsel özetlerini hazırlamayı deneyebilirsin."
  },

  "İşitsel": {
    headline: "İşitsel Çalışma Tercihin Öne Çıkıyor",
    message:
      "Bir konuyu dinlemek, sesli tekrar etmek veya başka birine anlatmak çalışırken sana yardımcı olabilecek yollar arasında olabilir. Notlarını sesli okumayı, kendi cümlelerinle anlatmayı ve soru-cevap yöntemiyle tekrar yapmayı deneyebilirsin."
  },

  "Dokunsal": {
    headline: "Uygulayarak Çalışma Tercihin Öne Çıkıyor",
    message:
      "Bir konuyla aktif biçimde uğraşmak, uygulamak, hareket etmek veya somut örnekler kullanmak sana yardımcı olabilecek yollar arasında olabilir. Deneyler, modeller, kartlar, kısa çalışma blokları ve uygulamalı etkinlikleri deneyebilirsin."
  }
};

const dominantFeedback = STUDENT_FEEDBACK_MAP[max];

const studentFeedback = {
  eyebrow: "ÖĞRENME TERCİHLERİN",

  title: "Nasıl Çalışmak Sana Daha Yakın?",

  headline:
    dominantFeedback?.headline ||
    "Bir Çalışma Tercihin Öne Çıkıyor",

  highlights: sortedStyles.map(item => item.subject),

  message:
    dominantFeedback?.message ||
    "Yanıtların, bazı çalışma ve öğrenme yollarının sana diğerlerinden daha yakın gelebileceğini gösteriyor.",

  counselorNote:
    "Bu sonuç seni tek bir öğrenme biçimine sabitlemez. Farklı derslerde ve farklı konularda görsel, işitsel ve uygulamalı yöntemleri birlikte kullanmak işine yarayabilir. Sana en çok yardımcı olan yöntemleri deneyerek keşfetmen önemlidir.",

  btnText: "Öğrenme Tercihlerimi Gördüm"
};
  
  // --- YENİ EKLENEN STANDART PAKETLEME (ZARF) ---
  // VAK bir "Risk" testi değil, Öğrenme Stili "Profil" testidir.
  // Radar ekranında uyarı vermemesi için masterRisk 'none' bırakılır.
  const topPercentage = Math.round((s[max] / 20) * 100);

  return {
    // 1. Ortak Dil (StudentFolders burayı okuyacak)
    riskScore: topPercentage, // En baskın alanın eşleşme yüzdesi
    masterRisk: "none",
    isCritical: false, 
    domain: "profile",        // Profil / Akademik alan

    // 2. Mevcut Detaylı Veriler (Dokunmadık)
   summary: `ÖNE ÇIKAN ÖĞRENME TERCİHİ: ${max.toUpperCase()}`,

analysis:
  `Yanıtlar incelendiğinde ${max} çalışma ve öğrenme tercihinin diğer alanlara göre daha fazla öne çıktığı görülmektedir. Bu sonuç öğrencinin yalnızca bu yöntemle öğrenebileceği anlamına gelmez. Farklı ders ve görevlerde görsel, işitsel ve uygulamalı yöntemlerin birlikte kullanılması destekleyici olabilir.`,
    chartData: [
  {
    subject: 'Görsel',
    rawCount: s['Görsel'],
    A: Math.round((s['Görsel'] / 20) * 100),
    fullMark: 100
  },
  {
    subject: 'İşitsel',
    rawCount: s['İşitsel'],
    A: Math.round((s['İşitsel'] / 20) * 100),
    fullMark: 100
  },
  {
    subject: 'Dokunsal',
    rawCount: s['Dokunsal'],
    A: Math.round((s['Dokunsal'] / 20) * 100),
    fullMark: 100
  }
],
    topStyle: max,
scores: s,

// 🌟 Öğrenci test sonrası kişisel geri bildirimi
studentFeedback: studentFeedback,

risks: [],
    colorCode: "blue",
    recommendations:
  `${max} tercihini destekleyen çalışma yöntemleri diğer görsel, işitsel ve uygulamalı stratejilerle birlikte denenebilir. Öğrenci için en işlevsel yöntemler ders ve görev türüne göre değerlendirilmelidir.`
  };
};